import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef
} from '@angular/material/bottom-sheet';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-theme-modal',
  standalone: true,
  imports: [CommonModule,  FontAwesomeModule],
  templateUrl: './theme-modal.component.html',
  styleUrl: './theme-modal.component.css'
})
export class ThemeModalComponent {
  faXmark = faXmark;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public theme: any,
    private bottomSheetRef: MatBottomSheetRef<ThemeModalComponent>
  ) {}

  close() {
    this.bottomSheetRef.dismiss();
  }

  scrollToContact() {
    this.bottomSheetRef.dismiss('contact');
  }
}
